import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import axios from 'axios'

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  hasLoadedOnce: false
}

const getters = {
  isAuthenticated: (state) => !!state.token,
  authStatus: (state) => state.status
}

// const config = {
//   headers: {
//     'Content-Type': 'multipart/form-data'
//   }
// }

const actions = {
  [AUTH_REQUEST]: ({
    commit,
    dispatch
  }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
    //   const formData = new FormData()

    //   formData.append('username', user.email)
    //   formData.append('password', user.password)

    //   var user: {
    //     email: user.email,
    //     password: user.password
    // },

      axios({ url: '/api/login', data: user, method: 'POST' })
        .then((resp) => {
          const token = resp.data.token
          
          //   console.log(token)
          localStorage.setItem('user-token', token)
          // Add the following line:
          if (token) {
            axios.defaults.headers.common['Authorization'] = 'bearer ' + token
          }
          
          commit(AUTH_SUCCESS, resp)
          dispatch(USER_REQUEST)
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({
    commit
  }) => {
    return new Promise((resolve) => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('user-token')
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.token
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
